import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdEdit } from 'react-icons/md';
import toast from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';
import TableTemplate from '../../../../components/table/index';
import { getAllPanicLog } from '../../../../controllers/PanicLogController';

const TableComponent = ({ t }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    const columns = useMemo(() => [
        { field: 'name', title: t('common.name.title'), sortable: true },
        { field: 'status', title: t('common.status.title'), sortable: true },
        { field: 'created_at', title: t('common.created.title'), sortable: true },
        { field: 'updated_by', title: t('common.updated.by'), sortable: true },
        { field: 'updated_at', title: t('common.updated.title'), sortable: true },
    ], [t]);
    
    const actions = useMemo(() => [
        (row) => (
            <button
                className='focus:outline-none text-xl md:text-2xl text-secondary hover:text-primary focus:text-primary'
                onClick={() => navigate(`/panic-log/${row.id}/user/${row.user_id}/edit`)}
            >
                <MdEdit />
            </button>
        ),
    ], [navigate]);
    
    const filters = useMemo(() => [
        { field: 'status', label: 'Status', by: t('common.status.pending'), labelBy: t('common.status.pending'), mode: 'exact' },
        { field: 'status', label: 'Status', by: t('common.status.handling'), labelBy: t('common.status.handling'), mode: 'exact' },
        { field: 'status', label: 'Status', by: t('common.status.resolved'), labelBy: t('common.status.resolved'), mode: 'exact' },
    ], [t]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                const result = await getAllPanicLog();
                const formattedRows = result.panic_log.map((panicLog) => ({
                    id: panicLog.id,
                    user_id: panicLog.user.id,
                    name: panicLog.user.name,
                    status: t(`common.status.${panicLog.status.toLowerCase()}`),
                    created_at: panicLog.created_at,
                    updated_by: panicLog.updated_by ?? '-',
                    updated_at: panicLog.updated_at
                }));
                
                setRows(formattedRows);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        fetchData();
    }, [t]);
    
    if (loading) {
        return (
        <Skeleton className='h-96 w-full rounded-lg' />
        );
    };
    
    return (
        <div>
            <TableTemplate
                rows={rows}
                columns={columns}
                actions={actions}
                filters={filters}
                fileName={t('menu.panicLog')}
            />
        </div>
    );
};

export default TableComponent;
